<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">订单[{{ OrdersSN }}]支付信息</div>
            <div class="mb20" v-for="(item, index) in list" :key="index">
                <div class="error" v-if="item.Select == 'false'">[{{ item.Orders_SN }}]: {{ item.Message }}</div>
                <el-descriptions v-else title="" :column="2" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="订单号">
                        <div class="rows">{{ item.Orders_SN }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="订单类型">
                        <div class="rows">{{ item.DiscountCateName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="待支付金额">
                        <div>￥{{ item.Amount }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="支付方式">
                        <div>{{ item.PayName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="付款凭证">
                        <div>
                            <div>
                                <el-button size="mini" type="primary" @click="chooseVoucher({ id: item.Orders_ID, index: index, price: item.Amount })">选择凭证</el-button>
                                <span style="color: red; margin-left: 10px">若有多张凭证请全部选择后再点击“提交”按钮</span>
                            </div>
                            <div style="margin-top: 10px" v-if="item.ReceiptList && item.ReceiptList.length > 0">
                                <el-table :data="item.ReceiptList" ref="Table" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Receipt_ID" label="ID" width="120" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_BankName" label="汇入银行" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Code" label="汇款单位" align="center" width="200" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Amount" label="汇款金额" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Addtime" label="录入时间" align="center"></el-table-column>
                                    <el-table-column prop="residuePrice" label="本次分配金额" align="center"></el-table-column>
                                    <el-table-column label="移除" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="removeClk({ index: index, childrenIndex: scope.$index, id: scope.row.Receipt_ID })">移除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="button-container">
                <el-button v-if="list.length > 0 && list.some((item) => item.Select !== 'false')" type="primary" @click="submit">{{ this.OrdersAuditStatus == '1' ? '提交' : '保存' }}</el-button>
                <el-button type="primary" @click="goBack">返回</el-button>
            </div>
            <el-dialog title="选择凭证" :visible.sync="isShowVoucher" width="1200px" :before-close="handleClose" v-if="isShowVoucher" append-to-body>
                <PackOrderVoucher :cateid="cateid" :residuePrice="residuePrice" @getPaymentReceipts="getPaymentReceipts"></PackOrderVoucher>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import PackOrderVoucher from '@/components/packOrderVoucher';

export default {
    components: {
        PackOrderVoucher
    },
    props: {
        orderOperate: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            OrdersID: '', //合同id
            OrdersSN: '', //合同SN
            OrdersAuditStatus: '', //合同审核状态
            batchOrderId: '', //当前选中的订单id
            relate_orders: [],
            list: [],
            nowIndex: 0, //当前选择凭证的列表索引
            cateid: '', //当前选择凭证的id
            residuePrice: 0, //当前选择凭证的剩余金额
            isShowVoucher: false //是否显示凭证列表
        };
    },
    mounted() {
        if (this.orderOperate) {
            this.OrdersID = this.orderOperate.OrdersID;
            this.OrdersSN = this.orderOperate.OrdersSN;
            this.OrdersAuditStatus = this.orderOperate.OrdersAuditStatus;
            this.batchOrderId = this.orderOperate.batchId;
            this.CheckSPCOrdersBatchPay();
        }
    },
    methods: {
        //
        async CheckSPCOrdersBatchPay() {
            let result = await this.$newsApi.order.CheckSPCOrdersBatchPay({
                OrdersID: this.OrdersID,
                relate_orders: this.batchOrderId
            });
            this.list = result.data.data.map((item) => {
                return {
                    ...item,
                    ReceiptList: []
                };
            });
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].Select == 'true') {
                    this.relate_orders.push(this.list[i].Orders_ID);
                }
            }
            let popShowIndex = this.list.findIndex((item) => item.Orders_IsNoCustomerSign == 1);
            if (popShowIndex != -1) {
                this.$message('免盖章订单，请注意付款金额需等于订单金额！');
            }
        },
        // 选择凭证
        chooseVoucher(e) {
            let residuePrice = 0; //当前选择订单的剩余金额
            this.nowIndex = e.index;
            let arr = this.list[e.index].ReceiptList;
            // 判断当前选择的订单已选凭证列表里面的金额
            for (let i = 0; i < arr.length; i++) {
                residuePrice += Number(arr[i].residuePrice);
            }

            if (residuePrice > e.price) {
                // 凭证价格大于了订单支付金额 默认值为0
                residuePrice = 0;
            } else if (residuePrice == 0) {
                // 凭证价格等于0 默认值为订单价格
                residuePrice = e.price;
            } else {
                residuePrice = (e.price - residuePrice).toFixed(2);
            }
            this.cateid = e.id;
            this.residuePrice = residuePrice;
            this.isShowVoucher = true;
        },
        goBack() {
            // this.$router.push({
            //     path: '/orderManagement/contractmanagementDetails',
            //     query: {
            //         id: this.OrdersID
            //     }
            // });
            this.$emit('BatchPaymentRes', false);
        },
        // 保存
        async submit() {
            let json = {};
            let arr = JSON.parse(JSON.stringify(this.list));
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].ReceiptList.length > 0) {
                    json['Receipt_ID_' + arr[i].Orders_ID] = arr[i].Receipt_ID;
                    json['Receipt_Amount_' + arr[i].Orders_ID] = arr[i].Receipt_Amount;
                }
            }
            json.relate_orders = this.relate_orders.join();
            json = JSON.stringify(json);
             let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.SPCOrders_BatchPay({
                OrdersID: this.OrdersID,
                Json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading

            if (result.data.Resultcode == 0) {
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                // this.$router.go(-1);
                this.$emit('BatchPaymentRes', false);
            }
        },
        handleClose(done) {
            this.isShowVoucher = false;
        },
        // 凭证列表
        getPaymentReceipts(json) {
            // 需要整和当前所有的Receipt_Amount,Receipt_ID参数
            if (this.list[this.nowIndex].ReceiptList.length > 0) {
                json['Receipt_ID_' + this.list[this.nowIndex].Orders_ID] = this.list[this.nowIndex].Receipt_ID + ',' + json['Receipt_ID_' + this.list[this.nowIndex].Orders_ID];
                json['Receipt_Amount_' + this.list[this.nowIndex].Orders_ID] = this.list[this.nowIndex].Receipt_Amount + json['Receipt_Amount_' + this.list[this.nowIndex].Orders_ID];
                this.ShowOrdersPaymentReceipt(json);
            } else {
                this.ShowOrdersPaymentReceipt(json);
            }
        },
        // 显示凭证列表
        async ShowOrdersPaymentReceipt(e) {
            let json = JSON.stringify(e);
            let result = await this.$newsApi.order.ShowOrdersPaymentReceipt({
                Json: json,
                cateid: this.list[this.nowIndex].Orders_ID
            });
            // 合并到当前的数据中
            this.list[this.nowIndex].ReceiptList = result.data.data.list;
            this.list[this.nowIndex].Receipt_Amount = result.data.data.Receipt_Amount;
            this.list[this.nowIndex].Receipt_ID = result.data.data.Receipt_ID;

            let needList = result.data.data.Receipt_Amount.split(',');
            for (let i = 0; i < this.list[this.nowIndex].ReceiptList.length; i++) {
                this.list[this.nowIndex].ReceiptList[i].residuePrice = needList[i].split('|')[1];
            }
            this.isShowVoucher = false;
        },
        // 移除
        removeClk(e) {
            this.$confirm('确定删除当前凭证吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let listData = this.list[e.index].ReceiptList.filter((item) => item.Receipt_ID != e.id);
                    if (listData.length == 0) {
                        this.list[e.index].receiptShow = false;
                        this.list[e.index].Receipt_Amount = '';
                        this.list[e.index].Receipt_ID = '';
                    } else {
                        let amountArr = [];
                        let idArr = [];
                        for (let i = 0; i < listData.length; i++) {
                            amountArr.push(listData[i].Receipt_ID + '|' + listData[i].residuePrice);
                            idArr.push(listData[i].Receipt_ID);
                        }
                        this.list[e.index].Receipt_Amount = amountArr.join();
                        this.list[e.index].Receipt_ID = idArr.join();
                    }
                    this.list[e.index].ReceiptList = listData;
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}

.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}

.links {
    color: #409eff;
    cursor: pointer;
}

.red {
    color: #f56c6c;
    margin-right: 10px;
}

.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }

    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none;
        /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none;
        /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none;
        /* 去掉表格行的边框 */
    }

    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}

.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}

.cart-list {
    background-color: #ffffff;
    font-size: 14px;

    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;

        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }

    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}

.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;

    span {
        color: red;
        padding-right: 20px;
    }
}

.flex {
    display: flex;
    align-items: center;
}

.mb20 {
    margin-bottom: 20px;
}

.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
/* 禁用所有滚动条 */
.content,
.hw-content,
.content * {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}
.content,
.hw-content
 {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

/* 禁用弹窗滚动条 */
::v-deep .el-dialog {
    overflow: hidden !important;
   overflow-y: hidden !important;
}

::v-deep .el-dialog__body {
    overflow: hidden !important;
    overflow-y: hidden !important;
}
</style>